import { request, useQuery } from '@applyboard/ui-utils';
import { Deserializer } from 'jsonapi-serializer';
import { z } from 'zod';
var ApplicationStage = z.object({
  id: z.string(),
  displayName: z.string()
});
export function useApplicationStages() {
  var _useQuery = useQuery(['application_stages', {
      pkg: 'ab-application'
    }], function () {
      return request('/awa/v1/workflows/default/application_stages', {
        schema: z.array(ApplicationStage),
        deserializer: new Deserializer({
          keyForAttribute: 'camelCase'
        })
      });
    }),
    data = _useQuery.data,
    isLoading = _useQuery.isLoading;
  return {
    applicationStages: data,
    isLoadingApplicationStages: isLoading
  };
}